module.exports = __webpack_public_path__ + "images/mdj/common/common_icon_dj-ab87502829f7848d0f0f17c15c0390e3.png";